module.exports = __webpack_public_path__ + "img/directory-structure.5fe2c10f.png";